export default __webpack_public_path__ + "static/media/imgIntitucion.826e5830.png";